/* sts-bundle.js — the Frequently bought together bundle in the cart
   (prototype v6.2, handoff §7). Loaded by sections/sts-header.liquid on the
   product page, the cart page, and any page while the cart holds a bundle.

   A bundle is the lines assets/sts-fbt.js added together, each with the
   hidden property `_bundle`: the products' handles, sorted, "+"-joined.

   1. Breaking it. A bundle is whole while every handle in its key still has
      a line carrying that key. When one is gone (the cart page, the LlamaCart
      drawer, anywhere), the rest lose `_bundle` and become regular lines,
      merged into a regular line of the same variant and plan when there is
      one. Lowering a quantity keeps the line, so it keeps the bundle. Every
      other property (_sts_src, _sts_origin #643) stays. Decided from a fresh
      /cart.js read, never from an event's copy.
   2. The discount is Shopify's (an automatic discount whose title contains
      "Bundle"). Nothing here prices a line. The cart page's badge, "You save"
      and "Bundle savings" rows are Liquid; the drawer gets the same badge and
      savings row here, from the lines' discount allocations.
   3. Staff simulator only (STS.state.flags.preview, which the head refuses on
      the published theme): while no line carries a real bundle allocation,
      10% off the regular price is PAINTED on bundle lines (badge, line total,
      "You save", "Bundle savings (10%)", Subtotal) so QA can see the look.
      The drawer gets the badge only. Checkout is never touched. */
(function () {
  'use strict';
  var w = window;
  var d = document;
  var STS = w.STS = w.STS || {};
  if (STS.bundle) return;
  STS.bundle = true;
  var PCT = 10; /* the simulator's stand-in only */
  var base = ((w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/') + 'cart';
  var page = d.querySelector('.sts-cart[data-section-type="cart"]');
  /* "0": the server saw no bundle line, so nothing to read until the cart
     changes (a product page view costs no /cart.js). */
  var none = !!d.currentScript && d.currentScript.getAttribute('data-has') === '0';
  var cart = null;
  var busy = false;
  var again = false;
  var faked = false;
  var tSync = 0;
  var qPaint = false;

  function call(path, body) {
    return w.fetch(base + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }
  function keyOf(it) { return String((it && it.properties && it.properties._bundle) || ''); }
  function planId(it) {
    var a = it && it.selling_plan_allocation;
    return a && a.selling_plan ? String(a.selling_plan.id) : '';
  }
  /* The unit price before Subscribe & save. */
  function regular(it) {
    var a = it.selling_plan_allocation;
    return a && a.compare_at_price > a.price ? a.compare_at_price : (it.original_price || it.price || 0);
  }
  /* [cents the bundle discount took off, its percentage] */
  function cutOf(it) {
    var c = 0;
    var p = 0;
    if (keyOf(it)) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (!/bundle/i.test(app.title || '')) return;
        c += +a.amount || 0;
        if (app.value_type === 'percentage') p = Math.round(+app.value);
      });
    }
    var r = regular(it) * it.quantity;
    return [c, c && !p && r ? Math.round(c * 100 / r) : p];
  }
  function sim() {
    var f = STS.state && STS.state.flags;
    return !!(f && f.preview);
  }
  function money(c) { return STS.money ? STS.money.cents(c) : (c / 100).toFixed(2); }
  function el(tag, cls) { var e = d.createElement(tag); e.className = cls; return e; }
  function put(e, t) { if (e && e.textContent !== t) e.textContent = t; }
  function drop(e) { if (e && e.parentNode) e.parentNode.removeChild(e); }

  // ------------------------------------------------------------ 1. breaking

  function broken(c) {
    var have = {};
    var keys = [];
    (c.items || []).forEach(function (it) {
      var k = keyOf(it);
      if (!k) return;
      if (!have[k]) { have[k] = {}; keys.push(k); }
      have[k][it.handle] = 1;
    });
    return keys.filter(function (k) {
      return k.split('+').some(function (h) { return !have[k][h]; });
    });
  }

  /* One line out of a broken bundle, or null when every bundle is whole. */
  function freeOne(c) {
    var bad = broken(c);
    var line = null;
    var twin = null;
    (c.items || []).forEach(function (it) { if (!line && bad.indexOf(keyOf(it)) > -1) line = it; });
    if (!line) return null;
    (c.items || []).forEach(function (it) {
      if (!twin && it !== line && it.variant_id === line.variant_id && !keyOf(it) && planId(it) === planId(line)) twin = it;
    });
    if (twin) {
      return call('/change.js', { id: twin.key, quantity: twin.quantity + line.quantity })
        .then(function () { return call('/change.js', { id: line.key, quantity: 0 }); });
    }
    var props = {};
    Object.keys(line.properties || {}).forEach(function (k) { if (k !== '_bundle') props[k] = line.properties[k]; });
    var item = { quantity: line.quantity, properties: props };
    if (planId(line)) item.selling_plan = Number(planId(line));
    return call('/change.js', Object.assign({ id: line.key }, item)).then(function (after) {
      var stuck = (after.items || []).some(function (it) {
        return it.variant_id === line.variant_id && keyOf(it) === keyOf(line) && planId(it) === planId(line);
      });
      if (!stuck) return after;
      /* A store that ignores properties on change.js: the line again without
         the key, then the old one out. */
      item.id = line.variant_id;
      return call('/add.js', { items: [item] })
        .then(function () { return call('/change.js', { id: line.key, quantity: 0 }); });
    });
  }

  function heal(c, n) {
    var step = n < 6 ? freeOne(c) : null;
    if (!step) return Promise.resolve(n ? c : null);
    return step.then(function () { return call('.js'); }).then(function (next) { return heal(next, n + 1); });
  }

  /* The theme's two "the cart was written" events, and theme.js's own
     re-render of the cart page (assets/sts-cart.js does the same). */
  function announce(c) {
    ['sts:cart:updated', 'theme:cart:change'].forEach(function (name) {
      d.dispatchEvent(new CustomEvent(name, { detail: { cart: c }, bubbles: true }));
    });
    if (page) d.dispatchEvent(new CustomEvent('theme:cart:reload'));
  }

  /* A cart change that lands while a pass is running gets a pass of its own. */
  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    function done() { busy = false; paint(); if (again) soon(); }
    call('.js').then(function (c) {
      cart = c;
      return heal(c, 0);
    }).then(function (after) {
      if (after) { cart = after; announce(after); }
      done();
    }, done);
  }
  function soon() { clearTimeout(tSync); tSync = setTimeout(sync, 80); }

  // -------------------------------------------------------------- 2. paint

  function paint() { if (!qPaint) { qPaint = true; (w.requestAnimationFrame || setTimeout)(paintNow); } }
  function paintNow() {
    qPaint = false;
    if (!cart) return;
    var real = (cart.items || []).some(function (it) { return cutOf(it)[0] > 0; });
    var fake = !real && sim();
    paintDrawer(fake);
    paintPage(fake);
  }

  /* LlamaCart's rows in cart order; a row whose variant does not line up is
     matched by variant alone, and only when that is unambiguous. */
  function paintDrawer(fake) {
    var dr = d.getElementById('lcu-llama-cart');
    if (!dr) return;
    var lines = cart.items || [];
    var rows = Array.prototype.slice.call(dr.querySelectorAll('.lcu__drawer__item'));
    var tot = 0;
    var pct = 0;
    rows.forEach(function (row, i) {
      var a = row.querySelector('a[href*="variant="]');
      var m = a && /variant=(\d+)/.exec(a.getAttribute('href'));
      var v = m ? m[1] : '';
      var line = rows.length === lines.length && lines[i] && String(lines[i].variant_id) === v ? lines[i] : null;
      if (!line && v) {
        var hit = lines.filter(function (l) { return String(l.variant_id) === v; });
        if (hit.length === 1) line = hit[0];
      }
      var b = line ? cutOf(line) : [0, 0];
      tot += b[0];
      if (b[1]) pct = b[1];
      var text = b[0] ? 'Bundle · ' + b[1] + '% off' : fake && line && keyOf(line) ? 'Bundle · ' + PCT + '% off' : '';
      var badge = row.querySelector('.sts-bbadge');
      var title = row.querySelector('.lcu__drawer__item-title');
      if (!text) { drop(badge); return; }
      if (!badge && title) { badge = el('span', 'sts-bbadge'); title.insertAdjacentElement('afterend', badge); }
      put(badge, text);
    });
    var sum = dr.querySelector('.sts-lcu-sum');
    var sv = sum && sum.querySelector('.sts-lcu-bsave');
    if (tot && sum && !sv) {
      sv = el('p', 'sts-lcu-bsave');
      sv.innerHTML = '<span></span><span></span>';
      sum.insertBefore(sv, sum.firstChild);
    }
    if (!sv) return;
    if (!tot) { drop(sv); return; }
    put(sv.firstChild, 'Bundle savings' + (pct ? ' (' + pct + '%)' : ''));
    put(sv.lastChild, '−' + money(tot));
  }

  /* The cart page: Liquid draws the real discount. Only the simulator's
     stand-in is painted here, from each row's data-sts-bl
     (regular unit | quantity | line total | Subscribe & save | real cut). */
  function paintPage(fake) {
    if (!page) return;
    var cut = 0;
    if (fake) {
      Array.prototype.slice.call(page.querySelectorAll('[data-sts-bundle]')).forEach(function (row) {
        var f = String(row.getAttribute('data-sts-bl') || '').split('|').map(Number);
        var q = f[1] || 0;
        var c = Math.round((f[0] || 0) * PCT / 100) * q;
        var cell = row.querySelector('.sts-cart__total');
        var lt = cell && cell.querySelector('[data-sts-lt]');
        if (!lt || !c) return;
        cut += c;
        if (!row.querySelector('.sts-bbadge')) {
          var t = row.querySelector('.sts-cart__title');
          if (t) t.insertAdjacentElement('afterend', el('span', 'sts-bbadge'));
        }
        put(row.querySelector('.sts-bbadge'), 'Bundle · ' + PCT + '% off');
        put(lt, money((f[2] || 0) - c));
        put(cell.querySelector('.sts-cart__was') || cell.appendChild(el('s', 'sts-cart__was')), money((f[0] || 0) * q));
        put(cell.querySelector('.sts-cart__save') || cell.appendChild(el('span', 'sts-cart__save')), 'You save ' + money((f[3] || 0) + c));
      });
    }
    var box = page.querySelector('[data-cart-subtotal]');
    var sv = box && box.querySelector('[data-sts-bsave-fake]');
    if (cut && box && !sv) {
      sv = el('p', 'sts-cart__sum sts-cart__sum--save');
      sv.setAttribute('data-sts-bsave-fake', '');
      sv.innerHTML = '<span>Bundle savings (' + PCT + '%)</span><span></span>';
      box.insertBefore(sv, box.firstChild);
    }
    if (sv) { if (cut) put(sv.lastChild, '−' + money(cut)); else drop(sv); }
    /* The Subtotal follows the stand-in, and goes back to the cart's own
       figure once there is nothing to fake. */
    var fin = page.querySelector('[data-cart-final]');
    if (fin && (cut || faked)) put(fin, money(cart.total_price - cut));
    faked = !!cut;
  }

  // --------------------------------------------------------------- wiring

  function watch(node) {
    if (node && !node.__stsBundle && w.MutationObserver) {
      node.__stsBundle = true;
      new MutationObserver(paint).observe(node, { childList: true, subtree: true, characterData: true });
    }
  }
  function watchDrawer() { watch(d.getElementById('lcu-llama-cart')); paint(); }

  ['sts:cart:updated', 'theme:cart:change', 'upsell:cart-updated', 'lcu:smart-cart:updated'].forEach(function (name) {
    d.addEventListener(name, function () { soon(); watchDrawer(); });
  });
  d.addEventListener('lcu:cart:toggle', watchDrawer);
  d.addEventListener('sts:state', paint);
  watch(page);
  watchDrawer();
  if (page || !none) sync();
})();
